import React from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "../../../../../axios";
let Teacher_id = localStorage.getItem("Teacher_id");
let Teacher_Json = JSON.parse(Teacher_id);

const ScheduleCardPopup = ({ props }) => {
  const handleDeactivate = async () => {
    let body = {
      status: "draft",
    };
    let res = await axios.put(`/api/v1/homework/updateStatus/${props}`, body);
    console.log(res);
    if (res.status === 200) {
      window.location.reload();
    }
  };
  const handleDelete = () => {
    axios.delete(`/api/v1/homework/delete/${props}`, {
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        teacher_id: Teacher_Json,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          window.location.reload()
        }
        console.log(response);
      })
  }
  return (
    <>
      <div className=" p-3 main_card_popup_box ">
        <NavLink to={`/EditScheduleHw`} state={{ homework_id: props }}>
          <button className="main_card_popup_button">Edit</button>
        </NavLink>
        <button
          className="main_card_popup_button"
          onClick={() => {
            handleDelete();
          }}
        >
          Delete
        </button>
        <button
          className="main_card_popup_button"
          onClick={() => {
            handleDeactivate();
          }}
        >
          Deactivate
        </button>
      </div>
    </>
  );
};

export default ScheduleCardPopup;
